import styled from 'styled-components';

interface Props {
  size?: number;
}

export const Container = styled.div`
  display: flex;
  color: black;
  gap: 15px;
  flex-wrap: wrap;
`;

export const Card = styled.div`
  min-width: 150px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 15px;
  background-color: ${(props) => props.theme.colors.contrast};
  border-radius: 10px;
  cursor: ${(props) => props.onClick && 'pointer'};
  max-height: 90px;

  svg {
    font-size: 26px;
    color: ${(props) => props.theme.colors.text};
  }
`;

export const Value = styled.h1<Props>`
  font-size: ${(props) => props.size ?? 20}px;
  color: ${(props) => props.theme.colors.text};
`;

export const Label = styled.label`
  color: ${(props) => props.theme.colors.text};
`;

export const Description = styled.p`
  margin-top: -5px;
  font-size: 12px;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;
